import Vue from 'vue';
import { Amplify, PubSub, Auth } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import {LAMBDA_CONFIG_CONTRIBUYENTE, AWS_ENV} from '@/config'
import LambdaInvoke from '@/library/utils/LambdaInvoke';

const plugin = {
	install(Vue, options){
		
		Vue.prototype.$mensajeria = new Mensajeria(options);
	}
}

class Mensajeria{
	constructor(options){
		
		this.frecuenciaSeg = 1000*60*.5;
		this.ultimaLlamada = null;
		this.__store = options.store;
		this.listaTopicos = new Map();
		this._topicoSeleccionado = null;
		this._subscription;
		this.iotPluggableAdded = false;

		this.accionesSuscritas = ['empresas/selectEmisor'];
		this.__store.subscribeAction(function(action, state){
			if( this.accionesSuscritas.includes(action.type) ){
				
				if( Object.hasOwn(action.payload, 'rut') ){
					const username = state.usuario.username;
					const contribuyente = action.payload.rut;
					this.getConfig(username, contribuyente)
				}
			}
			
		}.bind(this));

		this.handlers = {
			notificacion(mensaje){

			}
		}
	}
	get topico(){	return this._topicoSeleccionado;	}
	set topico(topico){	this._topicoSeleccionado = topico;	}
	get subscription(){	return this._subscription;	}
	set subscription(subscription){	this._subscription = subscription;	}

	manejarEvento(mensaje){
		const {
			provider, value
		} = mensaje;

		const delta = (new Date().getTime() - this.ultimaLlamada);

		// Si no se ha llamado a esta funcion, se ejecuta la api
		// si no se ha llamado a esta function dentro de 30 segs, se ejecuta la api
		// si esta en estado de LOADING, NO SE EJECUTA
		if(
			this.ultimaLlamada != null
			&& delta < this.frecuenciaSeg
			|| this.__store.getters['mensajeria/loading']
		){
			return;
		}

		this.ultimaLlamada = new Date().getTime();

		switch(value.tipo){
			case 'notificacion':
				
				const contribuyente = this.__store.getters['empresas/selectedRut'];
				const username = this.__store.getters['usuario/usuario'];
				this.__store.dispatch('mensajeria/getMensajes', {contribuyente,username}) 
			break;
			default:
				
			break;
		}
	}

	cambiarTopico(contribuyente,config){
		
		if( !this.listaTopicos.has(contribuyente) ){
			this.listaTopicos.set(contribuyente, config);
		}
		this.topico = config.topicoContribuyente;
		try{
			
			this.suscribir(contribuyente)
			
		}catch(e){
			console.error('--',e)
			throw e;
		}
	}
	agregarTopico(topico, contribuyente){
		
	}
	seleccionarTopico(topico){
		
	}
	getTopico(contribuyente, usuario){
	}
	suscribir(contribuyente){

		const {topicoContribuyente, endpoint, region } = this.listaTopicos.get(contribuyente)

		if(!this.iotPluggableAdded) {
			const iotConfig = {
				'aws_pubsub_region': region,
				'aws_pubsub_endpoint': endpoint
			};
			Amplify.addPluggable(new AWSIoTProvider(iotConfig));
			this.iotPluggableAdded = true;
		}

		const that = this;

		if( this.subscription ){
			this.subscription.unsubscribe();
		}
		
		this.subscription = PubSub.subscribe(topicoContribuyente).subscribe({
			next: function(message) {
				that.manejarEvento(message)
			},
			error: function(error) {
				console.error('Error:', error);
			},
			complete: function() {
				console.log('Connection closed');
			}
		});
		
	}
	desubscribir(){
		this.subscription.unsubscribe();
		this.topico = null;	
	}
	async getConfig(username, contribuyente){
		try{
			
			const payload = {contribuyente, username, env: AWS_ENV};
			let body = await LambdaInvoke(LAMBDA_CONFIG_CONTRIBUYENTE, payload);
			const {
				config:{
					notificaciones
				}
			} = body;
			
			this.cambiarTopico(contribuyente, notificaciones)
			return body;
		}catch(err){
			console.trace(err)
			throw err;
		}
	}
}

// Vue.use(plugin)

export default plugin;